// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ordersDetailsFooter {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}", "",{"version":3,"sources":["webpack://src/components/OrderDetails/OrderDetailsFooter/OrdersDetailsFooter.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":[".ordersDetailsFooter {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
